import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import React from 'react';
import ActionBubbleTooltip from './ActionBubbleTooltip';
import { PREMIUM_FEATURE_TOOLTIP } from '../helpers/subscription';

export default function PremiumFeatureBadge({ sx, placement = 'top' }) {
    return (
        <ActionBubbleTooltip title={PREMIUM_FEATURE_TOOLTIP} placement={placement}>
            <WorkspacePremiumIcon
                fontSize="small"
                sx={{ color: 'warning.main', ml: 0.75, verticalAlign: 'middle', ...sx }}
            />
        </ActionBubbleTooltip>
    );
}
